module.exports = __webpack_public_path__ + "static/img/cfpro_pay_help2.59cc914.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cfpro_pay_help2.png
// module id = 6TCA
// module chunks = 1